import React, { useContext, useMemo } from 'react'
import {
  View,
  ViewStyle,
} from 'react-native'
// import { ImageBackground } from 'react-native'

import { HERO_BACKGROUND_IMAGE_URL } from '@data/config/images'

import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Element } from './Element'

import { ComponentsContext, TokensContext, BreakpointContext } from './context'
import { applyStyles } from './util/applyStyles'

import { useBreakpoint } from './useBreakpoint'

interface ScreenProps {
  justifyContent?: 'center'
  alignItems?: 'center'
  variant?: string
  children: React.ReactNode
}

export const Screen = ({
  justifyContent,
  alignItems,
  children,
  variant,
}: ScreenProps) => {
  const insets = useSafeAreaInsets()

  const tokensContext = useContext(TokensContext)
  const componentsContext = useContext(ComponentsContext)
  const breakpointContext = useContext(BreakpointContext)

  const screenStyles = useMemo(() => {
    return applyStyles(
      tokensContext,
      componentsContext,
      breakpointContext,
      { justifyContent, alignItems },
      'Screen',
      variant
    )
  }, [
    tokensContext,
    componentsContext,
    breakpointContext,
    justifyContent,
    alignItems,
    variant,
  ])

  // Calculate base padding values from styles
  const basePaddingLeft =
    screenStyles.paddingLeft ||
    screenStyles.paddingHorizontal ||
    screenStyles.padding ||
    0
  const basePaddingRight =
    screenStyles.paddingRight ||
    screenStyles.paddingHorizontal ||
    screenStyles.padding ||
    0
  const basePaddingBottom =
    screenStyles.paddingBottom ||
    screenStyles.paddingVertical ||
    screenStyles.padding ||
    0

  return (
    // <StrictMode>
    <View
      style={[
        screenStyles,
        {
          // Use CSS calc() with env() for safe areas on web
          // Adds safe area inset on top of base padding
          paddingLeft: `calc(env(safe-area-inset-left, 0px) + ${basePaddingLeft}px)`,
          paddingRight: `calc(env(safe-area-inset-right, 0px) + ${basePaddingRight}px)`,
          paddingBottom: `calc(env(safe-area-inset-bottom, 0px) + ${basePaddingBottom}px)`,
        } as any,
      ]}
    >
      {children}
    </View>
    // </StrictMode>
  )
}

// Web-only background style (cast through unknown since these are web-only props)
const gradientBackgroundStyle = {
  flexGrow: 1,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 100%',
  backgroundImage: `url(${HERO_BACKGROUND_IMAGE_URL})`,
} as unknown as ViewStyle

export const GradientBackgroundScreen = (screenProps: ScreenProps) => {
  return (
    // <StrictMode>
    <Element style={gradientBackgroundStyle}>
      {/* <TransformImage
        as={ImageBackground}
        imageUrl={HERO_BACKGROUND_IMAGE_URL}
        // maxHeight={100}
        maxWidth='max'
        transformations={{ c: 'force' }}
        variant='contentCentered'
      > */}
      <Screen {...screenProps} variant='gradientBackgroundScreen' />
      {/* </TransformImage> */}
    </Element>
    // </StrictMode>
  )
}
